import { of } from "rxjs";
import { ofType, combineEpics } from "redux-observable";
import { tap, ignoreElements } from "rxjs/operators";
import { loadingTemplateAbstracts, loadedTemplateAbstracts, loadingTemplate, loadedTemplate, savingTemplate, savedTemplate, loadTemplate, creatingTemplate, createdTemplate, navigateToTemplate as navigateToTemplate$1, registeringDataSource, registeredDataSource, setUserContext } from "../ducks/AnalysisTemplateActions.js";
import analysisTemplateActionTypes from "../ducks/AnalysisTemplateConstants.js";
import { AnalysisTemplateUserContextParams } from "../../../../models/AnalysisTemplateUserContextParams.js";
import AnalysisTemplateResource from "../resources/AnalysisTemplate.resource.js";
import * as ReduxObservablesEpicUtils from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { produceUserContextRouteQueryStringEpics } from "@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics";
import { EXP_QUERY_STRINGS } from "@ane/core/lib/constants/QueryString.constants";
import { AnalysisTemplateRouteUtils } from "@ane/exp-data/lib/routes/AnalysisTemplateRoute.utils";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { AsyncRequestStatus } from "@ane/core/lib/models";
import { matchesRootPathname } from "@ane/exp-data/lib/routes/Route.utils";
const getTemplateAbstractsArgs = {
  filterOnType: analysisTemplateActionTypes.LOAD_TEMPLATE_ABSTRACTS,
  loadResource: (payload, state) => {
    return AnalysisTemplateResource.getTemplatesAbstracts(!!state && state.analysisTemplate.userContext.debug_useFakeData);
  },
  loadingAction: loadingTemplateAbstracts,
  loadedAction: (successData, payload) => {
    return of(loadedTemplateAbstracts(successData));
  }
};
const getTemplateAbstracts = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getTemplateAbstractsArgs);
const getTemplateArgs = {
  filterOnType: analysisTemplateActionTypes.LOAD_TEMPLATE,
  loadResource: (payload, state) => {
    return AnalysisTemplateResource.readTemplate(payload);
  },
  loadingAction: loadingTemplate,
  loadedAction: (successData, payload) => of(loadedTemplate(successData))
};
const getTemplate = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(getTemplateArgs);
const saveTemplateArgs = {
  filterOnType: analysisTemplateActionTypes.SAVE_TEMPLATE,
  loadResource: (payload, state) => {
    return AnalysisTemplateResource.saveTemplate(payload.templateContent);
  },
  loadingAction: savingTemplate,
  // reload the current template so the content is up to date.
  loadedAction: (successData, payload, error) => {
    if (!!error) {
      return of(savedTemplate(error));
    }
    return of(loadTemplate(payload.templateName), savedTemplate(null));
  }
};
const saveTemplate = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(saveTemplateArgs);
const createTemplateArgs = {
  filterOnType: analysisTemplateActionTypes.CREATE_TEMPLATE,
  loadResource: (payload, state) => {
    return AnalysisTemplateResource.saveTemplate(payload);
  },
  loadingAction: creatingTemplate,
  // reload the current template so the content is up to date.
  loadedAction: (successData, payload, error) => {
    if (!!error) {
      return of(createdTemplate(error));
    }
    return of(navigateToTemplate$1(successData), createdTemplate(null));
  }
};
const createTemplate = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(createTemplateArgs);
const navigateToTemplate = (action$) => {
  return action$.pipe(
    ofType(analysisTemplateActionTypes.NAVIGATE_TO_TEMPLATE),
    tap(
      (action) => !!action.payload ? NavigationService.navigateTo(
        AnalysisTemplateRouteUtils.routes.view.url({
          templateName: action.payload
        })
      ) : NavigationService.navigateTo(AnalysisTemplateRouteUtils.routes.root.url())
    ),
    ignoreElements()
  );
};
const registerDataSourceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic({
  filterOnType: analysisTemplateActionTypes.REGISTER_DATA_SOURCE,
  loadResource: (payload, state) => {
    return AnalysisTemplateResource.metricSetCreateOrUpdate(payload);
  },
  loadingAction: () => registeringDataSource(),
  // reload the current template so the content is up to date.
  loadedAction: (successData, payload, error) => {
    if (!!error) {
      return of(registeredDataSource({ data: "error", status: AsyncRequestStatus.Failed, error }));
    }
    return of(
      registeredDataSource({ data: "done", status: AsyncRequestStatus.Completed, error: "" }),
      navigateToTemplate$1("")
    );
  }
});
const provideAnalysisTemplateEpics = (history) => {
  const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(
    AnalysisTemplateUserContextParams,
    setUserContext,
    analysisTemplateActionTypes.SET_PARTIAL_USER_CONTEXT,
    analysisTemplateActionTypes.SET_USER_CONTEXT,
    (store) => store.analysisTemplate.userContext,
    history,
    (pathname) => {
      return matchesRootPathname(pathname, AnalysisTemplateRouteUtils.routes.root.path());
    },
    EXP_QUERY_STRINGS
  );
  const analysisTemplateEpics = combineEpics(
    getTemplateAbstracts,
    getTemplate,
    createTemplate,
    saveTemplate,
    navigateToTemplate,
    registerDataSourceEpic,
    ...Object.values(setUserContextFromRouteQueryString)
  );
  return analysisTemplateEpics;
};
export {
  createTemplate,
  getTemplate,
  getTemplateAbstracts,
  navigateToTemplate,
  provideAnalysisTemplateEpics,
  registerDataSourceEpic,
  saveTemplate
};
//# sourceMappingURL=AnalysisTemplateEpics.js.map
